import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {IboxxIndexDetailsPageComponent} from './iBoxx/iboxx-index-details-page/iboxx-index-details-page.component';
import {IboxxScreenerPageComponent} from './iBoxx/iboxx-screener-page/iboxx-screener-page.component';
import {IboxxNewsPageComponent} from './iBoxx/iboxx-news-page/iboxx-news-page.component';
import {CarbonLandingPageComponent} from './carbon/carbon-landing-page/carbon-landing-page.component';
import {CarbonIndexDetailPageComponent} from './carbon/carbon-index-detail-page/carbon-index-detail-page.component';
import {IndicesDocsPageComponent} from './indices-docs-page/indices-docs-page.component';
import {FuturesScreenerPageComponent} from './iBoxx/futures-screener-page/futures-screener-page.component';
import {TrsScreenerPageComponent} from './iBoxx/trs-screener-page/trs-screener-page.component';
import {EsgScreenerPageComponent} from './iBoxx/esg-screener-page/esg-screener-page.component';
import {FuturesDocumentPageComponent} from './iBoxx/futures-document-page/futures-document-page.component';
import {TrsDocumentPageComponent} from './iBoxx/trs-document-page/trs-document-page.component';
import {EsgDocumentPageComponent} from './iBoxx/esg-document-page/esg-document-page.component';
import {TrsCalcPageComponent} from './iBoxx/trs-calc-page/trs-calc-page.component';
import {UcitsLandingPageComponent} from './ucits-landing-page/ucits-landing-page.component';
import {UcitsDetailsPageComponent} from './ucits-details-page/ucits-details-page.component';
import {HealthCheckComponent} from './health-check/health-check.component';

const routes: Routes = [
  {path: '', redirectTo: '/iBoxx/Screener', pathMatch: 'full'}, // DEFAULT ROUTE
  {path: 'Carbon/Home', component: CarbonLandingPageComponent},
  {path: 'Carbon/details/:indexURL', component: CarbonIndexDetailPageComponent},
  // {path: 'EMIX/Screener', component: EmixLandingPageComponent},
  // {path: 'EMIX/details/:indexURL', component: EmixDetailsPageComponent},
  // {path: 'EMIX/docs/:pageName', component: EmixDocumentPageComponent},
  {path: 'iBoxx/details/:indexURL', component: IboxxIndexDetailsPageComponent},
  {path: 'iBoxx/Screener', component: IboxxScreenerPageComponent},
  {path: 'Indices/news', component: IboxxNewsPageComponent},
  {path: 'Indices/docs/:pageName', component: IndicesDocsPageComponent},
  {path: 'iBoxx/Futures/Screener', component: FuturesScreenerPageComponent},
  {path: 'Futures/docs/:pageName', component: FuturesDocumentPageComponent},
  {path: 'iBoxx/TRS/Screener', component: TrsScreenerPageComponent},
  {path: 'iBoxx/TRS/Calculator', component: TrsCalcPageComponent},
  {path: 'TRS/docs/:pageName', component: TrsDocumentPageComponent},
  {path: 'iBoxx/ESG/Screener', component: EsgScreenerPageComponent},
  {path: 'ESG/docs/:pageName', component: EsgDocumentPageComponent},
  {path: 'listUCITS', component: UcitsLandingPageComponent},
  {path: 'UCITS/:indexURL', component: UcitsDetailsPageComponent},
  {path: 'health', component: HealthCheckComponent}

// {path: '404', component: ErrorPageComponent},
  // {path: '**', redirectTo: '/404'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
